import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFaceExcited = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 729,
	height: 727,
	viewBox: "0 0 729 727",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3802_6225)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M728.69 344.84C728.69 147.48 584.88 0 385.02 0C282.2 0 194.23 39.32 133.02 104.22C189.94 61.62 262.13 36.9 343.66 36.9C543.52 36.9 687.33 184.38 687.33 381.74C687.33 477.05 653.419 561.1 595.659 622.35C678.269 560.53 728.69 461.05 728.69 344.84Z",
				fill: "#FFA6DD"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M41.35 344.84C41.35 249.53 75.26 165.48 133.02 104.23C50.42 166.05 0 265.52 0 381.73C0 578.02 143.81 726.57 343.67 726.57C446.49 726.57 534.47 687.25 595.67 622.35C538.75 664.95 466.56 689.67 385.03 689.67C185.17 689.67 41.36 541.13 41.36 344.83L41.35 344.84Z",
				fill: "#D900D6"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M343.67 36.9C262.14 36.9 189.95 61.63 133.03 104.22C75.2704 165.48 41.3604 249.52 41.3604 344.83C41.3604 541.12 185.17 689.67 385.03 689.67C466.56 689.67 538.76 664.94 595.67 622.35C653.43 561.09 687.34 477.05 687.34 381.74C687.34 184.39 543.53 36.9 343.67 36.9Z",
				fill: "#FF5FA2"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M423.294 344.118C421.203 342.104 418.455 340.811 415.519 340.64C412.585 340.469 409.721 341.418 407.53 343.303C405.339 345.188 403.973 347.877 403.703 350.804C403.433 353.733 404.301 356.643 405.98 359.011C407.22 360.714 408.471 362.322 409.848 363.948C421.754 378.38 441.201 389.661 462.265 389.287C483.339 389.203 502.138 377.825 513.946 363.62C515.307 362.015 516.543 360.428 517.772 358.748C519.327 356.554 520.18 353.871 519.988 351.147C519.798 348.425 518.599 345.905 516.622 344.11C514.644 342.315 512.02 341.366 509.292 341.439C506.563 341.512 503.974 342.621 501.94 344.38C500.671 345.452 499.433 346.436 498.14 347.423C486.644 356.199 474.148 361.26 462.017 361.319C449.889 361.484 437.682 356.404 426.856 347.28C425.638 346.256 424.479 345.232 423.294 344.118Z",
				fill: "#4D122C"
			}),
			/* @__PURE__ */ _jsx("g", {
				filter: "url(#filter0_g_3802_6225)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M383.799 310.677C385.654 312.871 388.205 314.463 391.074 314.982C393.942 315.502 396.867 314.922 399.246 313.345C401.625 311.768 403.297 309.299 403.935 306.456C404.574 303.611 404.102 300.641 402.802 298.079C401.989 296.544 401.18 295.113 400.245 293.612C392.422 280.642 377.365 267.65 358.023 267.224C338.74 266.731 323.42 278.503 314.76 290.74C313.739 292.153 312.842 293.516 311.936 294.973C310.582 297.259 309.906 299.959 310.252 302.638C310.597 305.316 311.91 307.733 313.949 309.395C315.988 311.056 318.62 311.855 321.312 311.652C324.006 311.451 326.514 310.245 328.48 308.457C329.481 307.576 330.437 306.785 331.446 305.972C340.383 298.742 349.579 294.819 357.285 295.134C364.982 295.229 373.461 299.772 381.242 307.896C382.12 308.809 382.943 309.694 383.799 310.677Z",
					fill: "#4D122C"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				filter: "url(#filter1_g_3802_6225)",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M584.203 308.838C586.28 310.823 588.986 312.134 591.894 312.346C594.801 312.558 597.648 311.671 599.846 309.85C602.044 308.029 603.444 305.396 603.776 302.501C604.109 299.605 603.324 296.702 601.76 294.292C600.788 292.853 599.832 291.515 598.743 290.122C589.586 278.057 573.233 266.738 553.955 268.37C534.729 269.93 520.747 283.263 513.437 296.351C512.571 297.864 511.824 299.314 511.078 300.859C509.974 303.276 509.59 306.033 510.218 308.66C510.845 311.286 512.408 313.55 514.612 314.986C516.816 316.421 519.518 316.936 522.173 316.448C524.83 315.962 527.196 314.496 528.961 312.509C529.863 311.527 530.73 310.638 531.646 309.723C539.765 301.584 548.492 296.707 556.188 296.201C563.851 295.477 572.764 299.093 581.365 306.345C582.335 307.159 583.247 307.952 584.203 308.838Z",
					fill: "#4D122C"
				})
			}),
			/* @__PURE__ */ _jsx("path", {
				opacity: .56,
				d: "M354.975 364.778C369.935 368.709 385.064 359.661 388.118 344.9C391.092 330.65 381.031 317.682 365.039 315.987C360.085 315.475 354.728 316.004 349.908 317.338C338.093 320.587 330.705 329.671 330.376 340.185C330.079 349.962 336.525 357.971 348.361 362.451C350.542 363.283 352.749 364.014 354.95 364.771L354.975 364.778Z",
				fill: "#FFA6DD"
			}),
			/* @__PURE__ */ _jsx("path", {
				opacity: .56,
				d: "M562.815 363.686C547.654 366.753 533.069 356.852 530.866 341.94C528.713 327.544 539.501 315.174 555.564 314.398C560.539 314.171 565.857 315.006 570.593 316.614C582.202 320.535 589.057 330.028 588.782 340.544C588.519 350.321 581.624 357.948 569.551 361.742C567.326 362.447 565.08 363.051 562.84 363.681L562.815 363.686Z",
				fill: "#FFA6DD"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter0_g_3802_6225",
			x: 306.892,
			y: 263.939,
			width: 100.596,
			height: 54.4989,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feTurbulence", {
					type: "fractalNoise",
					baseFrequency: "0.0099999997764825821 0.0099999997764825821",
					numOctaves: 3,
					seed: 6779
				}),
				/* @__PURE__ */ _jsx("feDisplacementMap", {
					in: "shape",
					scale: 6.540051460266113,
					xChannelSelector: "R",
					yChannelSelector: "G",
					result: "displacedImage",
					width: "100%",
					height: "100%"
				}),
				/* @__PURE__ */ _jsx("feMerge", {
					result: "effect1_texture_3802_6225",
					children: /* @__PURE__ */ _jsx("feMergeNode", { in: "displacedImage" })
				})
			]
		}),
		/* @__PURE__ */ _jsxs("filter", {
			id: "filter1_g_3802_6225",
			x: 506.646,
			y: 264.942,
			width: 100.476,
			height: 54.9547,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "BackgroundImageFix",
					result: "shape"
				}),
				/* @__PURE__ */ _jsx("feTurbulence", {
					type: "fractalNoise",
					baseFrequency: "0.0099999997764825821 0.0099999997764825821",
					numOctaves: 3,
					seed: 6779
				}),
				/* @__PURE__ */ _jsx("feDisplacementMap", {
					in: "shape",
					scale: 6.540051460266113,
					xChannelSelector: "R",
					yChannelSelector: "G",
					result: "displacedImage",
					width: "100%",
					height: "100%"
				}),
				/* @__PURE__ */ _jsx("feMerge", {
					result: "effect1_texture_3802_6225",
					children: /* @__PURE__ */ _jsx("feMergeNode", { in: "displacedImage" })
				})
			]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_3802_6225",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 728.69,
				height: 726.57,
				fill: "white"
			})
		})
	] })]
});
export default SvgFaceExcited;
